import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { useCart } from "../context/CartContext";
import { pageColors } from "../mock";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const { openCart } = useCart();

  useEffect(() => { document.title = "TMM|CHECKOUT"; }, []);

  return (
    <>
      <Header hoverColor={pageColors.fashion} compact={false} />
      <div className="payment-page" data-testid="payment-cancel-page">
        <XCircle size={56} className="payment-icon-warn" />
        <h1 className="payment-title" data-testid="payment-cancel-title">Checkout canceled</h1>
        <p className="payment-sub">
          No charge was made and your cart is exactly as you left it. Come back whenever you're ready.
        </p>
        <div className="payment-actions">
          <button
            className="btn-solid"
            onClick={() => { navigate("/shop"); openCart(); }}
            data-testid="payment-reopen-cart"
          >
            Review my cart
          </button>
          <button className="btn-ghost" onClick={() => navigate("/shop")} data-testid="payment-back-shop">
            Back to shop
          </button>
        </div>
      </div>
    </>
  );
}
